import { ContextService } from '../../../services/context_service';
import { DataService } from '../../../services/data_service';
import { Image, Page, Text, View } from '@react-pdf/renderer';
import { lazyInject } from '../../../services/inversify';
import { LineDiagram } from '../../datenauswertung/helper/lineChart';
import * as Moment from 'moment';
import * as React from 'react';
import { svgToPng } from '../../helper';

interface LastgangPdfProps extends React.ClassAttributes<any> {
    data: any;
    onDone: (pdfData: JSX.Element | Array<JSX.Element | JSX.Element[]>) => void;
}

interface LastgangPdfState {
    isLoading: boolean;
}

export class LastgangPdf extends React.Component<LastgangPdfProps, LastgangPdfState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false
        };
        this.getPdf = this.getPdf.bind(this);
        this.processPdf = this.processPdf.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;

    private avgLeistung: number = null;
    private dataHoechstleistung: any[] = [];
    private dataLastbereiche: any[] = [];
    private dataMonate: any[] = [];
    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 1, useGrouping: true });
    private formatFloat1: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1, useGrouping: true });
    private formatFloat2: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
    private jahresauslastung: number = null;
    private maxDatum: any = null;
    private maxLeistung: number = null;
    private minLeistung: number = null;
    private nutzungszeit: number = null;
    private unitLeistung: any = null;
    private unitVerbrauch: any = null;
    private verbrauch: number = null;

    componentDidMount(): void {
        // console.log('data: ', this.props.data);
        this.processPdf();
    }

    getDateRange(): string {
        const data: any = this.props.data || {};
        const timestampFrom: number = data.timestampFrom || null;
        const timestampTo: number = data.timestampTo || null;

        return timestampFrom && timestampTo
            ? `${Moment(timestampFrom).format('DD.MM.YYYY')} - ${Moment(timestampTo).format('DD.MM.YYYY')}`
            : null;
    }

    getKeyByUnit(name: string): string {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const powerUnits: any = data.powerUnits || {};
        const keys: string[] = [...Object.keys(energyUnits), ...Object.keys(powerUnits)];
        const units: any = data.units || {};
        let key: string = null;

        Object.keys(units).forEach((index: string) => {
            if (key === null && (units[index] || {}).key === name) {
                key = index;
            }
        });

        if (key === null && keys.indexOf(name) !== -1) {
            Object.keys(((data.data || {}).all || [])[0] || {}).forEach((key2: string) => {
                if (key === null && (key2 || '').toString().endsWith(`-${name}`)) {
                    key = key2;
                }
            });
        }

        return key;
    }

    getPdf(images: any[]): void {
        this.props.onDone([
            this.renderPageUebersicht(images),
            this.renderPageMonatsleistungen(images)
        ]);
    }

    getStyle(): any {
        return ({
            header: {
                fontSize: '18pt',
                fontFamily: 'Helvetica-Bold',
                color: '#555',
                width: '100%',
                height: 85,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relative',
                display: 'block'
            },
            headerImage: {
                width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerText: {
                marginTop: -3
            },
            headerSubText: {
                fontSize: '16pt',
                color: '#5e8bc2'
            },
            headerSubText2: {
                fontSize: '13pt',
                color: '#333',
                marginTop: 8
            },
            headerSubText3: {
                fontSize: '11pt',
                color: '#6692c2'
            },
            footer: {
                fontSize: '8pt',
                right: 40,
                bottom: 15,
                left: 40,
                width: '100%',
                height: 'auto',
                padding: 0,
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            footerPages: {
                right: 0,
                position: 'absolute'
            },
            chart_title: {
                fontSize: '10pt',
                fontFamily: 'Helvetica-Bold',
                color: '#555',
                margin: 'auto',
                padding: '4px 6px 4px 6px'
            },
            legend: {
                marginRight: 2,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            },
            legend_icon: {
                width: 6,
                height: 6,
                marginRight: 4,
                marginLeft: 4
            },
            legend_text: {
                fontSize: '8pt',
                color: '#555',
                marginRight: 4,
                display: 'flex',
                flexDirection: 'row'
            },
            text: {
                fontSize: '12pt',
                textAlign: 'justify'
            },
            wrapper: {
                fontSize: '9pt',
                width: 280,
                maxWidth: 280,
                margin: 'auto',
                marginTop: 0,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            tabelle: {
                margin: 'auto',
                marginTop: 0,
                marginLeft: 0,
                border: '1 solid black',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                color: '#555',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                fontSize: '10pt'
            },
            col_active: {
                color: 'white',
                backgroundColor: '#6692c3'
            },
            colgroup: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            },
            col1: {
                flexBasis: '32%'
            },
            col1_3: {
                flexBasis: '100%'
            },
            col2: {
                flexBasis: '34%'
            },
            col3: {
                flexBasis: '34%'
            },
            cell: {
                textAlign: 'left',
                padding: 2,
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                boxSizing: 'border-box'
            },
            cell_header: {
                fontFamily: 'Helvetica-Bold',
                fontWeight: 'bold',
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell1: {
            },
            cell1_header: {
            },
            cell2: {
            },
            cell2_header: {
            },
            cell3: {
            },
            cell3_header: {
            },
            right: {
                textAlign: 'right',
                justifyContent: 'flex-end'
            },
            page: {
                padding: 40,
                paddingBottom: 20
            },
            pdf: {
                fontFamily: 'Helvetica',
                fontSize: '9pt'
            }
        });
    }

    init(): void {
        this.setUnits();
        const data: any = this.props.data || {};
        const dataJahr: any = ((data.data || {})['1#y'] || [])[0] || {};
        const interval: number = data.interval || null;
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const keyVerbrauch: string = this.getKeyByUnit(this.unitVerbrauch) || null;
        const timestampFrom: number = data.timestampFrom || null;
        const timestampTo: number = data.timestampTo || null;
        const stunden: any[] = ((data.data || {}).all || [])
            .filter((item: any) => item.stamp >= timestampFrom && item.stamp <= timestampTo);
        const gesamtstunden: number = stunden.length
            ? Moment.duration((Moment.unix(stunden[stunden.length - 1].stamp / 1000)).diff(Moment.unix(stunden[0].stamp / 1000))).asHours()
            : null;
        let indexHour: number = 0;
        let lastHour: number = null;
        this.avgLeistung = dataJahr[keyLeistung] || null;
        this.dataHoechstleistung = [];
        this.dataLastbereiche = [];
        this.dataMonate = [];
        this.maxDatum = typeof dataJahr[`${keyLeistung}-max-stamp`] === 'number'
            ? Moment.unix(dataJahr[`${keyLeistung}-max-stamp`] / 1000) : null;
        this.maxLeistung = dataJahr[`${keyLeistung}-max`] || null;
        this.minLeistung = dataJahr[`${keyLeistung}-min`] || null;
        const maxDatum: string = this.maxDatum ? Moment(this.maxDatum).format('DD.MM.YYYY') : null;
        this.verbrauch = dataJahr[keyVerbrauch] || null;

        [...(data.data || {}).all || []].forEach((item: any) => {
            if (Moment(item.datetime).format('DD.MM.YYYY') === maxDatum) {
                this.dataHoechstleistung.push({ ...item, keyX: Moment(item.datetime).format('HH:mm') });
            };
        });

        [...(data.data || {}).all || []]
            .sort((a: any, b: any) => (+a[keyLeistung] || 0) < (+b[keyLeistung] || 0) ? 1 : -1)
            .forEach((item: any) => {
                if (item.stamp >= timestampFrom && item.stamp <= timestampTo) {
                    const keyX: number = Math.floor(++indexHour * (+interval / 3600));

                    if (keyX === lastHour) {
                        return;
                    }
                    this.dataLastbereiche.push({ ...item, keyX });
                    lastHour = keyX;
                }
            });

        [...(data.data || {})['1#M'] || []].forEach((item: any) => {
            if (item.stamp >= timestampFrom && item.stamp <= timestampTo) {
                const leistung: number = +(item || {})[`${keyLeistung}-max`];
                const verbrauch: number = +(item || {})[keyVerbrauch];
                this.dataMonate.push({
                    leistung: !isNaN(leistung) ? this.formatFloat1.format(leistung) : null,
                    name: item.stamp > 0 ? Moment(item.datetime).format('MMM') : null,
                    nameFull: item.stamp > 0 ? Moment(item.datetime).format('MMMM') : null,
                    values: [verbrauch],
                    verbrauch: !isNaN(verbrauch) ? this.formatFloat1.format(verbrauch) : null
                });
            }
        });
        this.nutzungszeit = this.maxLeistung > 0 ? this.verbrauch / this.maxLeistung : null;
        this.jahresauslastung = this.nutzungszeit > 0 && gesamtstunden > 0
            ? (this.nutzungszeit / ((data.data || {})['1#h'] || []).length) * 100 : null;
    }

    async processPdf(): Promise<void> {
        const charts: any[] = await [];
        const data: any[] = await [];
        const recharts: NodeListOf<HTMLElement> = document.querySelectorAll('.recharts-responsive-container');
        const styles: any = this.getStyle();

        for (let index = 0, length: number = recharts.length; index < length; ++index) {
            const chart: HTMLElement = recharts[index].querySelector('.recharts-surface');
            const id: string = recharts[index].id || null;
            const legend: NodeListOf<HTMLElement> = recharts[index].querySelectorAll('.recharts-legend-wrapper li');
            const legendItems: any[] = Array.from(legend)
                .map((li: any) => {
                    const color = `#${
                        ((li.firstChild.style.color || '').substr(4).split(')')[0].split(', '))
                            .map((rgb: number) => (+rgb).toString(16))
                            .join('')
                    }`;
                    return { data: li.lastChild.data, color };
                });

            if (!chart) {
                continue;
            }
            charts.push({
                ...(id ? { id } : {}),
                html: chart,
                legend: legendItems || []
            });
        }

        charts.forEach(async (item: any): Promise<void> => {
            const html: HTMLElement = item.html || <svg />;
            html.style.fontFamily = styles.pdf.fontFamily || null;
            html.style.fontSize = styles.pdf.fontSize || null;
            const id: string = item.id || null;
            const legend: any = item.legend || [];
            const rect = html.getBoundingClientRect();
            const svg = new XMLSerializer().serializeToString(html);
            const svgBlob = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
            const image: any = await svgToPng(svgBlob, rect.width, rect.height, 3);
            data.push({
                ...(id ? { id } : {}),
                image: <Image src={image} style={{ maxWidth: rect.width * 0.75 }} />,
                legend: legend ? this.renderPdfLegend(legend) : null
            });

            if (data.length === charts.length) {
                this.getPdf(data);
            }
        });
    }

    reduceData(data: any[], max: number = 730): any[] {
        data = data || [];
        const lastIndex: number = data.length - 1;
        const result: any[] = [];
        const step: number = Math.floor(data.length / max);

        if (data.length <= max) {
            return data;
        }

        data.forEach((item: any, index: number) => {
            if (index % step !== 0 && index !== lastIndex) {
                return;
            }
            result.push(item);
        });

        return result;
    }

    render(): JSX.Element | JSX.Element[] {
        this.init();

        return [
            this.renderDiagrammLastbereiche(),
            this.renderDiagrammHoechstleistung(),
            ...(this.renderMonatsleistungen() || [])
        ];
    }

    renderBenutzungsstunden(): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <View style={{ ...styles.tabelle, marginTop: 15 }}>
                <View style={styles.row}>
                    <View style={{ ...styles.colgroup, ...styles.col1, fontFamily: 'Helvetica-Bold' }}>
                        <View style={{ ...styles.cell, ...styles.cell1 }}>
                            <Text>Vollbenutzungsstunden</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col2 }}>
                        <View style={{ ...styles.cell, ...styles.cell2, ...styles.right }}>
                            <Text>{this.formatFloat2.format(this.nutzungszeit || 0)}</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col3 }}>
                        <View style={{ ...styles.cell, ...styles.cell3 }}>
                            <Text>h</Text>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    renderDiagrammHoechstleistung(): JSX.Element {
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const maxDatum: string = this.maxDatum ? Moment(this.maxDatum).format('DD.MM.YYYY') : null;
        const powerUnits: any = (this.props.data || {}).powerUnits || {};
        const unit: string = powerUnits[this.unitLeistung] || null;

        if (!keyLeistung) {
            return null;
        }
        const dataDiagram: any = {
            id: 'hoechstleistung',
            legendTitle: ['Leistung'],
            lineColor: ['#000'],
            lineWidth: [2],
            unit: [unit],
            visibleData: [keyLeistung]
        };
        const textLines: any[] = [{
            value: `Höchstleistung [${powerUnits[this.unitLeistung] || ''}] am ${maxDatum || ''}`,
            x: '50%',
            y: 0,
            dy: 11,
            style: { fontSize: '10pt', fontWeight: 'bold' },
            fill: '#555',
            textAnchor: 'middle'
        }];

        return (
            <div key={`diagram-hoechstleistung`} style={{ maxWidth: 0, maxHeight: 0, overflow: 'hidden', visibility: 'hidden' }}>
                <LineDiagram
                    data={this.dataHoechstleistung || []}
                    visibleData={dataDiagram.visibleData || []}
                    id={dataDiagram.id}
                    lineColor={dataDiagram.lineColor || []}
                    lineWidth={dataDiagram.lineWidth || []}
                    textLines={textLines}
                    singleYAxis
                    legendTitle={dataDiagram.legendTitle || []}
                    hideLegend
                    unit={dataDiagram.unit || []}
                    createNewTick
                    lineNoDot
                    containerSize={{ width: 600, height: 236 }}
                    lineChartProps={{ margin: { top: 20, right: 0, bottom: 5, left: 25 }, style: { display: 'inherit' } }}
                    X_padding={{ left: 0, right: 0 }}
                    X_dataKey='keyX'
                    xAxisProps={[{ label: { value: 'Uhrzeit', fontStyle: 'italic', fill: '#555', position: 'insideBottom', offset: -5 } }]}
                    yAxisProps={[
                        { width: 60, domain: null, ticks: null, label: { value: unit, fill: '#555', angle: -90, position: 'insideLeft' } }
                    ]}
                    bgColor='white'
                />
            </div>
        );
    }

    renderDiagrammLastbereiche(): JSX.Element {
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const powerUnits: any = (this.props.data || {}).powerUnits || {};
        const unit: string = powerUnits[this.unitLeistung] || null;

        if (!keyLeistung) {
            return null;
        }
        const dataDiagram: any = {
            id: 'lastbereiche',
            legendTitle: ['Leistung'],
            lineColor: ['#000'],
            lineWidth: [2],
            unit: [unit],
            visibleData: [keyLeistung]
        };
        const textLines: any[] = [{
            value: 'geordnete Jahresdauerlinie',
            x: '50%',
            y: 0,
            dy: 11,
            style: { fontSize: '10pt', fontWeight: 'bold' },
            fill: '#555',
            textAnchor: 'middle'
        }];

        return (
            <div key={`diagram-lastbereiche`} style={{ maxWidth: 0, maxHeight: 0, overflow: 'hidden', visibility: 'hidden' }}>
                <LineDiagram
                    data={this.reduceData(this.dataLastbereiche || [])}
                    visibleData={dataDiagram.visibleData || []}
                    id={dataDiagram.id}
                    lineColor={dataDiagram.lineColor || []}
                    lineWidth={dataDiagram.lineWidth || []}
                    textLines={textLines}
                    singleYAxis
                    legendTitle={dataDiagram.legendTitle || []}
                    hideLegend
                    unit={dataDiagram.unit || []}
                    createNewTick
                    lineNoDot
                    containerSize={{ width: 600, height: 236 }}
                    lineChartProps={{ margin: { top: 20, right: 0, bottom: 5, left: 25 }, style: { display: 'inherit' } }}
                    X_padding={{ left: 0, right: 0 }}
                    X_dataKey='keyX'
                    xAxisProps={[{ label: { value: 'Stunden', fontStyle: 'italic', fill: '#555', position: 'insideBottom', offset: -5 } }]}
                    yAxisProps={[
                        { width: 60, domain: null, ticks: null, label: { value: unit, fill: '#555', angle: -90, position: 'insideLeft' } }
                    ]}
                    bgColor='white'
                />
            </div>
        );
    }

    renderDiagrammMonatsleistung(jahr: number, monat: number): JSX.Element {
        const keyLeistung: string = this.getKeyByUnit(this.unitLeistung) || null;
        const powerUnits: any = (this.props.data || {}).powerUnits || {};
        const unit: string = powerUnits[this.unitLeistung] || null

        if (!keyLeistung || !jahr || !monat) {
            return null;
        }
        const dataDiagram: any = {
            id: `monatsleistung-${+Moment([jahr, monat - 1]) / 1000}`,
            legendTitle: ['Leistung'],
            lineColor: ['#f79646'],
            lineWidth: [1],
            unit: [unit],
            visibleData: [keyLeistung]
        };
        const key: string = `${jahr}-${monat}`;
        const data: any[] = [...((this.props.data || {}).data || {}).all || []].filter((item: any) => {
            item.keyDate = Moment(item.datetime).format('DD.MM.');
            return Moment(item.datetime).format('YYYY-M') === key;
        });
        const referenceLines: any[] = [{
            ifOverflow: 'extendDomain',
            // label: { value: 'Jahresspitzenlast', fontWeight: 'bold', fill: 'red', position: 'insideBottomRight' },
            stroke: 'red',
            strokeWidth: 2,
            y: this.maxLeistung
        }];
        const textLines: any[] = [{
            value: `${Moment([jahr, monat - 1]).format('MMMM')}: Leistung${unit ? ` [${unit}]` : ''}`,
            x: '50%',
            y: 0,
            dy: 11,
            style: { fontSize: '10pt', fontWeight: 'bold' },
            fill: '#555',
            textAnchor: 'middle'
        }];

        return (
            <div key={`diagram-${key}`} style={{ maxWidth: 0, maxHeight: 0, overflow: 'hidden', visibility: 'hidden' }}>
                <LineDiagram
                    data={data}
                    visibleData={dataDiagram.visibleData || []}
                    id={dataDiagram.id}
                    lineColor={dataDiagram.lineColor || []}
                    lineWidth={dataDiagram.lineWidth || []}
                    referenceLines={referenceLines}
                    textLines={textLines}
                    singleYAxis
                    legendTitle={dataDiagram.legendTitle || []}
                    hideLegend
                    unit={dataDiagram.unit || []}
                    createNewTick
                    lineNoDot
                    containerSize={{ width: 1050, height: 185 }}
                    lineChartProps={{ margin: { top: 20, right: 0, bottom: 0, left: 0 }, style: { display: 'inherit' } }}
                    X_padding={{ left: 0, right: 0 }}
                    X_dataKey='keyDate'
                    yAxisProps={[{ width: 60, domain: null, ticks: null }]}
                    bgColor='white'
                />
            </div>
        );
    }

    renderFooter(): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <View style={styles.footer} fixed>
                <Text>{Moment().format('DD.MM.YYYY')}</Text>
                <View style={styles.footerPages}>
                    <Text
                        render={({ pageNumber, totalPages }) => {
                            if (totalPages > 1) {
                                return `${pageNumber}/${totalPages}`;
                            }
                        }}
                        fixed
                    />
                </View>
            </View>
        );
    }

    renderHeader(): JSX.Element {
        const header = require('../../../img/logo_mittel2.png');
        const styles: any = this.getStyle();

        return (
            <View style={styles.header} fixed>
                <Text style={styles.headerText}>E-Tool</Text>
                <Text style={styles.headerSubText}>&nbsp;</Text>
                <Text style={styles.headerSubText2}>Lastgang</Text>
                <Text style={styles.headerSubText3}>{this.getDateRange()}</Text>
                <Image src={header} style={styles.headerImage} />
            </View>
        );
    }

    renderElektrischeArbeit(): JSX.Element {
        const energyUnits: any = (this.props.data || {}).energyUnits || {};
        const styles: any = this.getStyle();

        return (
            <View style={styles.tabelle}>
                <View style={styles.row}>
                    <View style={{ ...styles.colgroup, ...styles.col1, fontFamily: 'Helvetica-Bold' }}>
                        <View style={{ ...styles.cell, ...styles.cell1 }}>
                            <Text>Elektrische Arbeit</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col2 }}>
                        <View style={{ ...styles.cell, ...styles.cell2, ...styles.right }}>
                            <Text>{this.formatFloat.format(this.verbrauch || 0)}</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col3 }}>
                        <View style={{ ...styles.cell, ...styles.cell3 }}>
                            <Text>{energyUnits[this.unitVerbrauch] || null}</Text>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    renderElektrischeLeistung(): JSX.Element {
        const powerUnits: any = (this.props.data || {}).powerUnits || {};
        const styles: any = this.getStyle();

        return (
            <View style={{ ...styles.tabelle, marginTop: 15 }}>
                <View style={styles.row}>
                    <View style={{ ...styles.colgroup, ...styles.col1_3 }}>
                        <View style={{ ...styles.cell, ...styles.col1, fontFamily: 'Helvetica-Bold' }}>
                            <Text>Elektrische Leistung</Text>
                        </View>
                    </View>
                </View>
                {['Maximum', 'Minimum', 'Durchschnitt'].map((key: string, index: number) => {
                    const leistung: number = index === 0
                        ? this.formatFloat1.format(this.maxLeistung || 0)
                        : (index === 1
                            ? this.formatFloat1.format(this.minLeistung || 0)
                            : (index === 2 ? this.formatFloat1.format(this.avgLeistung || 0) : null)
                        );
                    return (
                        <View key={`leistung-${index}`} style={styles.row}>
                            <View style={{ ...styles.colgroup, ...styles.col1 }}>
                                <View style={{ ...styles.cell, ...styles.cell1 }}>
                                    <Text>{key}</Text>
                                </View>
                            </View>
                            <View style={{ ...styles.colgroup, ...styles.col2 }}>
                                <View style={{ ...styles.cell, ...styles.cell2, ...styles.right }}>
                                    <Text>{leistung}</Text>
                                </View>
                            </View>
                            <View style={{ ...styles.colgroup, ...styles.col3 }}>
                                <View style={{ ...styles.cell, ...styles.cell3 }}>
                                    <Text>{powerUnits[this.unitLeistung] || null}</Text>
                                </View>
                            </View>
                        </View>
                    );
                })}
            </View>
        );
    }

    renderJahresauslastung(): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <View style={{ ...styles.tabelle, marginTop: 15 }}>
                <View style={styles.row}>
                    <View style={{ ...styles.colgroup, ...styles.col1, fontFamily: 'Helvetica-Bold' }}>
                        <View style={{ ...styles.cell, ...styles.cell1 }}>
                            <Text>Jahresauslastung</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col2 }}>
                        <View style={{ ...styles.cell, ...styles.cell2, ...styles.right }}>
                            <Text>{this.formatFloat.format(this.jahresauslastung || 0)}</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col3 }}>
                        <View style={{ ...styles.cell, ...styles.cell3 }}>
                            <Text>%</Text>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    renderJahresuebersicht(): JSX.Element {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const powerUnits: any = data.powerUnits || {};
        const styles: any = this.getStyle();

        return (
            <View style={{ ...styles.tabelle, marginTop: 15, border: 0 }}>
                <View
                    style={{
                        ...styles.row, ...styles.row_header, borderTop: '1 solid black', borderRight: '1 solid black',
                        borderLeft: '1 solid black'
                    }}
                >
                    <View style={{ ...styles.colgroup, ...styles.col1_3 }}>
                        <View style={{ ...styles.cell, ...styles.cell_header }}>
                            <Text>Jahresübersicht</Text>
                        </View>
                    </View>
                </View>
                <View style={{ ...styles.row, borderBottom: '1 solid black', borderLeft: '1 solid black' }}>
                    <View style={{ ...styles.colgroup, ...styles.col1 }}>
                        <View style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1 }}>
                            <Text>Monat</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col2 }}>
                        <View style={{ ...styles.cell, ...styles.cell_header, ...styles.cell2 }}>
                            <Text>Verbrauch [{energyUnits[this.unitVerbrauch] || null}]</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col3, borderRight: '1 solid black' }}>
                        <View style={{ ...styles.cell, ...styles.cell_header, ...styles.cell3 }}>
                            <Text>Leistung [{powerUnits[this.unitLeistung] || null}]</Text>
                        </View>
                    </View>
                </View>
                {this.dataMonate.map((monat: any, index: number) =>
                    <View key={`monat-${index}`} style={styles.row}>
                        <View style={{ ...styles.colgroup, ...styles.col1 }}>
                            <View style={{ ...styles.cell, ...styles.cell1, borderLeft: '1 solid black' }}>
                                <Text>{monat.nameFull}</Text>
                            </View>
                        </View>
                        <View style={{ ...styles.colgroup, ...styles.col2, borderLeft: '1 solid black' }}>
                            <View style={{ ...styles.cell, ...styles.cell2, ...styles.right }}>
                                <Text>{monat.verbrauch}</Text>
                            </View>
                        </View>
                        <View style={{ ...styles.colgroup, ...styles.col3, borderRight: '1 solid black', borderLeft: '1 solid black' }}>
                            <View style={{ ...styles.cell, ...styles.cell3, ...styles.right }}>
                                <Text>{monat.leistung}</Text>
                            </View>
                        </View>
                    </View>
                )}
                <View style={{ ...styles.row, fontFamily: 'Helvetica-Bold' }}>
                    <View
                        style={{
                            ...styles.colgroup, ...styles.col1, borderTop: '1 solid black', borderBottom: '1 solid black',
                            borderLeft: '1 solid black'
                        }}
                    >
                        <View style={{ ...styles.cell, ...styles.cell1 }}>
                            <Text>Summe</Text>
                        </View>
                    </View>
                    <View
                        style={{
                            ...styles.colgroup, ...styles.col2, borderTop: '1 solid black', borderBottom: '1 solid black',
                            borderLeft: '1 solid black'
                        }}
                    >
                        <View style={{ ...styles.cell, ...styles.cell2, ...styles.right }}>
                            <Text>{this.formatFloat1.format(this.verbrauch || 0)}</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.colgroup, ...styles.col3, borderTop: '1 solid black', borderLeft: '1 solid black' }}>
                        <View style={{ ...styles.cell, ...styles.cell3 }}>
                            <Text>&nbsp;</Text>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    renderMonatsleistungen(): JSX.Element[] {
        const data: any = this.props.data || {};
        const timestampFrom: number = data.timestampFrom || null;
        const timestampTo: number = data.timestampTo || null;
        const dataMonate: any[] = ((data.data || {})['1#M'] || [])
            .filter((item: any) => item.stamp >= timestampFrom && item.stamp <= timestampTo);

        return dataMonate.map((item: any) => {
            if (typeof (item || {}).datetime === 'undefined') {
                return null;
            }
            return this.renderDiagrammMonatsleistung(Moment(item.datetime).year(), Moment(item.datetime).month() + 1);
        });
    }

    renderPageMonatsleistungen(images: any[]): JSX.Element {
        const monate: any[] = (images || [])
            .filter((item: any) => ((item || {}).id || '').startsWith('monatsleistung-'))
            .sort((a: any, b: any) => ((a || {}).id || '').toString().localeCompare(((b || {}).id || '').toString()));
        const styles: any = this.getStyle();

        if (!monate.length) {
            return null;
        }

        return (
            <Page key={`page-monate`} size='A4' orientation='landscape' style={styles.page}>
                {this.renderHeader()}
                {...monate.map((monat: any, index: number) =>
                    <View key={`monat-${index}`} style={{ margin: 'auto', marginTop: 0, marginRight: 0, marginBottom: 15 }}>
                        {monat.image || null}
                    </View>
                )}
                {this.renderFooter()}
            </Page>
        );
    }

    renderPageUebersicht(images: any[]): JSX.Element {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const hoechstleistung: any = (images || []).find((item: any) => (item || {}).id === 'hoechstleistung') || {};
        const lastbereiche: any = (images || []).find((item: any) => (item || {}).id === 'lastbereiche') || {};
        const monatsverbraeuche: any = (images || []).find((item: any) => (item || {}).id === 'monatsverbraeuche') || {};
        const styles: any = this.getStyle();

        return (
            <Page key={`page-uebersicht`} size='A4' orientation='landscape' style={styles.page}>
                {this.renderHeader()}
                <View style={{ marginBottom: 10, display: 'flex', flexDirection: 'row' }}>
                    {this.renderTabellen()}
                    <View style={{ flex: 1 }}>
                        {Object.keys(lastbereiche).length > 0 &&
                            <View style={{ margin: 'auto', marginTop: 0, marginRight: 0, marginBottom: 0 }}>
                                {lastbereiche.image || null}
                            </View>
                        }
                        {Object.keys(hoechstleistung).length > 0 &&
                            <View style={{ margin: 'auto', marginTop: 20, marginRight: 0, marginBottom: 0 }}>
                                {hoechstleistung.image || null}
                            </View>
                        }
                        {Object.keys(monatsverbraeuche).length > 0 &&
                            <View style={{ margin: 'auto', marginTop: 15, marginRight: 0, marginBottom: 0 }}>
                                <View style={styles.chart_title}>
                                    <Text>Monatsverbräuche [{energyUnits[this.unitVerbrauch] || null}]</Text>
                                </View>
                                {monatsverbraeuche.image || null}
                            </View>
                        }
                    </View>
                </View>
                {this.renderFooter()}
            </Page>
        );
    }

    renderPdfLegend(data: any): JSX.Element {
        const styles: any = this.getStyle();

        return data.map((item: any, index: number) =>
            <View key={`legend-${index}`} style={styles.legend}>
                {item.color && <Text style={{ ...styles.legend_icon, backgroundColor: item.color }}></Text>}
                {item.data && <Text style={styles.legend_text}>{item.data}</Text>}
            </View>
        );
    }

    renderTabellen(): JSX.Element {
        const styles: any = this.getStyle();

        return (
            <View style={styles.wrapper}>
                {this.renderElektrischeArbeit()}
                {this.renderElektrischeLeistung()}
                {this.renderJahresuebersicht()}
                {this.renderBenutzungsstunden()}
                {this.renderJahresauslastung()}
            </View>
        );
    }

    setUnits(): void {
        const data: any = this.props.data || {};
        const energyUnits: any = data.energyUnits || {};
        const energyKeys: string[] = Object.keys(energyUnits);
        const powerUnits: any = data.powerUnits || {};
        const powerKeys: string[] = Object.keys(powerUnits);
        const units: any = data.units || {};

        Object.keys(units).forEach((index: string) => {
            if (this.unitLeistung === null && powerKeys.indexOf((units[index] || {}).key) !== -1) {
                this.unitLeistung = units[index].key;
                this.unitVerbrauch = energyUnits[`${this.unitLeistung}h`] ? `${this.unitLeistung}h` : null;
            }

            if (this.unitVerbrauch === null && energyKeys.indexOf((units[index] || {}).key) !== -1) {
                this.unitVerbrauch = units[index].key;
                const keyEnergy: string = this.unitVerbrauch.substr(0, this.unitVerbrauch.length - 1);
                this.unitLeistung = powerUnits[keyEnergy] ? keyEnergy : null;
            }
        });
    }
}
